import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import PurpleButton from '../common/buttonTheme';
import useDrawerHistory from '../hooks/useDrawerHistory';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ConfirmDialogue({dialogueOpen,handleDecision,displayText,displayTitle}) {

  // Manage browser history for back button behavior
  useDrawerHistory(dialogueOpen, () => handleDecision(false), 'confirm-dialog');

  return (
    <div>
        <Dialog
        open={dialogueOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => {}}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{displayTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {displayText}
          </DialogContentText>
        </DialogContent>
        <DialogActions> 
          <PurpleButton variant="contained" onClick={() => handleDecision(true)}>Yes</PurpleButton>
          <PurpleButton variant="contained" onClick={() => handleDecision(false)}>No</PurpleButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}
